export const testFileSize = (fileSize: number) => fileSize < 700000
